<script setup>
import { ref } from 'vue';

import DsModal from 'JIX/components/ds/DsModal.vue';

const modal = ref();

defineExpose({
    show: () => modal.value.show(),
});
</script>

<template>
    <DsModal
        title="Mange neutrale svar"
        :show="false"
        ref="modal"
    >
        <p>
            Vi kan se du har brugt knappen 'Spring over' mange gange. Desto flere gange du bruger knappen, desto usikre bliver resultatet. Prøv så godt du kan at vælge en af de to svarmuligheder.
        </p>
        <template #footer>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Ok
            </button>
        </template>
    </DsModal>
</template>
